// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-div{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.644);
    color: white;
}

.body-div{
    height: 100%;    
    display: flex;    
}
.content-div{
    background-color: transparent;
    width: 100%;    
    overflow-y: auto;
}
.content-div::-webkit-scrollbar {
    display: none; 
  }
`, "",{"version":3,"sources":["webpack://./src/layout/layout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;EACf","sourcesContent":[".layout-div{\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.644);\n    color: white;\n}\n\n.body-div{\n    height: 100%;    \n    display: flex;    \n}\n.content-div{\n    background-color: transparent;\n    width: 100%;    \n    overflow-y: auto;\n}\n.content-div::-webkit-scrollbar {\n    display: none; \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
